// extracted by css-extract-rspack-plugin
export default {"modal":"CancelModal__modal--zPhVP","modalBody":"CancelModal__modalBody--Jcnx5","warning":"CancelModal__warning--y1Fdc","warningTitle":"CancelModal__warningTitle--ypl3u"};